module.exports = __webpack_public_path__ + "static/media/icon-shop-detail-background.83ebbf8e.png";